import React, { Component } from 'react'
import PropTypes from 'prop-types'
import InputRow from './InputRow'
import DataSource from '../DataSource'
import ManualInput from '../components/ManualInput'

class Addressify extends Component {
    constructor (props) {
        super(props)

        this.state = {
            addressList: [],
            showManualInput: false
        }
    }

    handleKeyDown (event) {
        event.persist()
        if (event.keyCode === 13) {
            event.preventDefault()
            this.handleEnterPress()
        }
    }

    handleChangeAddress (event) {
        event.persist()
        this.props.handleSetAddress({ [this.props.name ? this.props.name : 'address']: event.target.value }, () => {
            // Pass the event value here because the props have a lagged response
            this.getAddresses(event.target.value)
        })
    }

    handleAddressClick (address, event) {
        event.preventDefault()
        this.setAddress(address)
        this.clearAddressList()
        if (this.props.handleAddressSelected) {
		    this.props.handleAddressSelected(address)
        }
    }

    handleEnterPress () {
        if (this.state.addressLine.length > 0) {
		    const address = this.state.addressList[0].value
            this.setAddress(address)
            this.clearAddressList()
            if (this.props.handleAddressSelected) {
                this.props.handleAddressSelected(address)
            }
        }
    }

    setAddress (address) {
        this.props.handleSetAddress({ [this.props.name ? this.props.name : 'address']: address })
    }

    getAddresses (address) {
        if (address.length > 4) {
            this.loader.style.display = 'block'
            clearTimeout(this.sqTimer)
            this.sqTimer = setTimeout(() => {
                DataSource.getData(`/api/search/${address}`, result => {
                    this.handleResponse(result)
                })
            }, 500)
        }
    }

    handleResponse (result) {
        this.loader.style.display = 'none'
        if (result.length > 0) {
            this.setState({
                addressList: result
            })
        } else {
            this.setState({
                addressList: [
                    { id: '0', label: 'No address found.', value: this.props.value }
                ]
            })
        }
    }

    clearAddressList () {
        this.setState({ addressList: [] })
    }

    handleShowManualSearch (e) {
        e.preventDefault()
        this.setState({ showManualInput: true })
    }

    handleHideManualSearch (e) {
        e.preventDefault()
        this.setState({ showManualInput: false })
    }

    render () {
        const AddressList = this.state.addressList.slice(0, 6).map((item, key) => {
            return (
                <a key={key} href='#' onClick={event => this.handleAddressClick(item.value, event)}>{item.label}</a>
            )
        })

        return (
            <div className='addressify' ref={el => this.container = el}>
                <InputRow
                    name={this.props.name ? this.props.name : 'address'}
                    autoComplete='new-password'
                    value={this.props.value}
                    errors={this.props.errors}
                    label={(this.props.label ? this.props.label : 'Address')}
                    placeholder={(this.props.placeholder ? this.props.placeholder : '')}
                    handleChange={this.handleChangeAddress.bind(this)}
                    handleKeyDown={this.handleKeyDown.bind(this)}
                    className={this.props.className ? this.props.className : ''}
                    disabled={this.props.disabled ? this.props.disabled : false}
                >
                    {this.props.children}
                </InputRow>

                {this.state.showManualInput
                    ? <ManualInput handleHideManualSearch={this.handleHideManualSearch.bind(this)} setAddress={this.setAddress.bind(this)} clearAddressList={this.clearAddressList.bind(this)} />
                    : (this.state.addressList.length > 0
                        ? <div className='address-list'>
                            <span onClick={this.clearAddressList.bind(this)}><img src='/images/icon-close.svg' alt='Close' /></span>
                            {AddressList}
                            <a className='semi-bold' href='#' onClick={(e) => this.handleShowManualSearch(e)}>Can't find your address? Enter it manually</a>
                        </div>
                        : '')}
                <div className='inline-loader' ref={el => this.loader = el}>
                    <img src='/images/loader-anim-inline.svg' alt='...' className='not-ie' />
                    <img src='/images/loader-anim-inline-ie.gif' alt='...' className='ie' style={{ width: '60px' }} />
                </div>
            </div>
        )
    }
}

Addressify.propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    handleSetAddress: PropTypes.func,
    handleAddressSelected: PropTypes.func

}

export default Addressify



// WEBPACK FOOTER //
// ./resources/js/elements/Addressify.js